import axios from '../axios'
// 分页查询教育局
export const educationPage = (data) => {
  return axios({
    url: '/console/education/page',
    method: 'GET',
    data: data
  })
}
// 获取所有启用教育局列表
export const educationList = (data) => {
  return axios({
    url: '/console/education/list',
    method: 'GET',
    data: data
  })
}
//教育局下的学校分页
export const pageForUnderEducation = (data) => {
  return axios({
    url: '/console/school/pageForUnderEducation',
    method: 'GET',
    data: data
  })
}
//新增教育局
export const saveEducation = (data) => {
  return axios({
    url: '/console/education/save',
    method: 'POST',
    data: data
  })
}
//更新教育局
export const updateEducation = (data) => {
  return axios({
    url: '/console/education/update',
    method: 'POST',
    data: data
  })
}

//分页查询学校
export const schoolPageForCompany = (data) => {
  return axios({
    url: '/console/school/pageForCompany',
    method: 'GET',
    data: data
  })
}
//新增学校
export const saveSchool = (data) => {
  return axios({
    url: '/console/school/save',
    method: 'POST',
    data: data
  })
}
//更新学校
export const updateSchool = (data) => {
  return axios({
    url: '/console/school/update',
    method: 'POST',
    data: data
  })
}

//获取未绑定教育局的学校
export const selectUnBind = (data) => {
  return axios({
    url: '/console/school/selectUnBind',
    method: 'GET',
    data: data
  })
}
//更新学校
export const bindSchool = (data) => {
  return axios({
    url: '/console/school/bind',
    method: 'POST',
    data: data
  })
}

//查询用户列表
export const accountListUser = (data) => {
  return axios({
    url: '/con/account/listUser',
    method: 'POST',
    data: data
  })
}
// 修改用户状态（启用&禁用）
export const updateUserStatus = (data) => {
  return axios({
    url: '/con/account/updateUserStatus',
    method: 'GET',
    data
  })
}

// 不传就是当前学校下已启用学科列表
export const subjectEnableList = (data) => {
  return axios({
    url: '/console/subject/enable_list',
    method: 'GET',
    data
  })
}
// 获取所有未禁用的学校
export const schoolEnableList = (data) => {
  return axios({
    url: '/console/school/enable_list',
    method: 'GET',
    data
  })
}
// 校验手机号
export const checkMobile = (data) => {
  return axios({
    url: '/con/account/checkMobile',
    method: 'GET',
    data
  })
}
// 创建用户
export const createUser = (data) => {
  return axios({
    url: '/con/account/createUser',
    method: 'GET',
    data
  })
}
// 创建用户
export const homeworkClassList = (data) => {
  return axios({
    url: '/console/homework_class/list',
    method: 'GET',
    data
  })
}
// 修改用户信息
export const updateUser = (data) => {
  return axios({
    url: '/con/account/updateUser',
    method: 'GET',
    data
  })
}

//启用禁用教育局
export const educationSwitch = (data) => {
  return axios({
    url: '/console/education/switch',
    method: 'POST',
    data
  })
}
//禁用学校
export const schoolSwitch = (data) => {
  return axios({
    url: '/console/school/switch',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/informationMaintenance.js